import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import LandingBanner from "../Components/LandingPage/Banner";
import ScrollToTop from "../Components/ScrollToTop";
import data from '../Json/header.json'
import LandingFeature from "../Components/LandingPage/Features";
import LandingArticle from "../Components/LandingPage/Article";
import LandingServices from "../Components/LandingPage/services";
import LandingReview from "../Components/LandingPage/Review";
import AnimatedComponent from "../Components/AnimateComponent";



const LandingPage = () => {

    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.substring(1);
            const element = document.getElementById(id);
            const basename = "/integrity-checks";
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });

                // Remove only the hash and its value
                // const newUrl = `${basename}${location.pathname}${location.search}`;
                // window.history.replaceState(null, "", newUrl);
            }
        }
        else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [location]);

    return (
        <>
            <LandingBanner />
            <AnimatedComponent delay={0.2}>
                <LandingFeature data={data.features} />
            </AnimatedComponent>
            <LandingArticle data={data.article} />
            <LandingServices data={data.services} />
            {/* <AnimatedComponent delay={0.5}>
                <LandingReview data={data.Review} />
            </AnimatedComponent> */}

        </>
    )
}
export default LandingPage;